<template>
  <div class="ab-wrapper" :class="{ loading }">
    <div>
      <component
        :is="component"
        :key="loading"
        :url="componentUrl"
        :seo="seo"
        :user-info="userInfo"
        :instructor="instructor"
        :stats="stats"
        :version="componentVersion"
        :component-version="componentVersion"
      />
    </div>
  </div>
</template>

<script>
import LandingPage from './LandingPage';
import AffiliatePage from './AffiliatePage';

export default {
  components: { LandingPage, AffiliatePage },
  props: {
    originalComponent: { type: String, default: '' },
    url: { type: String, default: '' },
    abTesting: { type: Object, default: () => ({}) },
    seo: { type: Object, default: () => ({}) },
    userInfo: { type: Object, default: () => ({}) },
    instructor: { type: Object, default: () => ({}) },
    stats: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: true,
      component: this.originalComponent, // component to load
      componentUrl: this.url, // url in component
      componentVersion: this.abTesting.defaultPageVersion || '0', // version in component
    };
  },
  created() {
    // dev tests
    if (this.$route.query.version && this.$route.query.version !== this.version && process.client && window.location.origin.indexOf('365datascience.com') === -1) {
      this.componentVersion = this.$route.query.version;
    }
  },
  mounted() {
    try {
      if (this.abTesting.experimentId) {
        const ctx = this;

        // eslint-disable-next-line no-undef
        gtag('event', 'optimize.callback', {
          name: this.abTesting.experimentId,
          callback: (value) => {
            ctx.componentVersion = String(value);
            if (ctx.abTesting.newPageToOpen && ctx.abTesting.newPageToOpen.version === ctx.componentVersion) { // from ab testing constant
              ctx.component = ctx.abTesting.newPageToOpen.component;
            }
            ctx.$nextTick(() => {
              ctx.loading = false;
            });
          },
        });

        // Fallback to showing content after 1 second if optimize not loading
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.abTesting.newPageToOpen && this.abTesting.newPageToOpen.version === this.componentVersion) { // from ab testing constant
              this.component = this.abTesting.newPageToOpen.component;
            }
            ctx.loading = false;
          }, 1500);
        });
      } else {
        this.$nextTick(() => {
          if (this.abTesting.newPageToOpen && this.abTesting.newPageToOpen.version === this.componentVersion) { // from ab testing constant
            this.component = this.abTesting.newPageToOpen.component;
          }
          this.loading = false;
        });
      }
    } catch (e) {
      this.$nextTick(() => {
        if (this.abTesting.newPageToOpen && this.abTesting.newPageToOpen.version === this.componentVersion) { // from ab testing constant
          this.component = this.abTesting.newPageToOpen.component;
        }
        this.loading = false;
      });
    }
  },
};
</script>

<style lang="scss">
.ab-wrapper {
  > * {
    transition: opacity 100ms ease-in;
  }

  &.loading > * {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
